import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import AnnouncementModal from "./components/AnnouncementModal";
import Home from "./pages/Home";
import Hakkimizda from "./pages/Hakkimizda";
import Hizmetler from "./pages/Hizmetler";
import Haberler from "./pages/Haberler";
import HaberDetay from "./pages/HaberDetay";
import Iletisim from "./pages/Iletisim";
import LegalPage from "./pages/LegalPage";
import KurumsalPage from "./pages/KurumsalPage";
import AracFilomuz from "./pages/AracFilomuz";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kurumsal/hakkimizda" element={<Hakkimizda />} />
            <Route
              path="/kurumsal/vizyon-misyon"
              element={<KurumsalPage type="vizyon-misyon" />}
            />
            <Route
              path="/kurumsal/kalite-politikamiz"
              element={<KurumsalPage type="kalite-politikamiz" />}
            />
            <Route
              path="/kurumsal/personel-politikamiz"
              element={<KurumsalPage type="personel-politikamiz" />}
            />
            <Route path="/hizmetlerimiz" element={<Hizmetler />} />
            <Route path="/arac-filomuz" element={<AracFilomuz />} />
            <Route path="/haberler" element={<Haberler />} />
            <Route path="/haberler/:id" element={<HaberDetay />} />
            <Route path="/iletisim" element={<Iletisim />} />
            <Route
              path="/kurumsal/kvkk-bilgilendirmesi"
              element={<LegalPage type="kvkk" />}
            />
            <Route
              path="/kurumsal/cerez-politikasi"
              element={<LegalPage type="cerez" />}
            />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <AnnouncementModal />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
